module.exports = __webpack_public_path__ + "img/tabs-03.f16c1f08.jpg";